const actions = {
  USERLOCATION_LOADING: "USERLOCATION_LOADING",
  USERLOCATION_UPDATE: "USERLOCATION_UPDATE",
  USERLOCATION_UPDATE_KEY_RESULT: "USERLOCATION_UPDATE_KEY_RESULT",
  USERLOCATION_ERROR: "USERLOCATION_ERROR",
  USERLOCATION_RESET: "USERLOCATION_RESET",
};

export default actions;